// extracted by mini-css-extract-plugin
export var root = "Menu-module--root--NwOYd";
export var full = "Menu-module--full--1_BQb";
export var sticky = "Menu-module--sticky--1JxiV";
export var animate = "Menu-module--animate--2FRpY";
export var show = "Menu-module--show--hM4vh";
export var menu = "Menu-module--menu--XvS32";
export var burger = "Menu-module--burger--1SzYC";
export var open = "Menu-module--open--3YkFi";
export var row = "Menu-module--row--3II2g";